import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Strategy } from 'client/voladeum/strategies/types';
import { SLICE } from 'ducks/slice';

import { strategy_default } from './defaults';

const initialState: Strategy = { ...strategy_default };

export const strategySlice = createSlice({
  name: SLICE.STRATEGY,
  initialState,
  reducers: {
    setStrategy: (_state, action: PayloadAction<Strategy>) => {
      return action.payload;
    },
    clearStrategy: () => {
      return initialState;
    },
  },
});

export const { setStrategy, clearStrategy } = strategySlice.actions;

export default strategySlice.reducer;
